<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Quality_Score_Module" langKey="Section_Title">Display</span>
    </div>
    <div class="custom-setting-section-context" cvLocalizedText [langSection]="'Quality_Score_Module'" [langKey]="'Quality_Score_Scale'">Quality Score Scale</div>
    <div class="custom-setting-section-body">
        <cxone-range-slider [(ngModel)]="settings.rangeValues"
            [min]="0"
            [max]="100"
            [step]="1"
            [startPoints]="points"
            [connect]="connect"
            [colorClasses]="['negativeRange', 'neutralRange', 'positiveRange']"
            [markerValues]="11"></cxone-range-slider>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div cvModuleCxoneCustomSettingSection after="view" [moduleManager]="moduleManager">
        <div class="form-group">
            <p class="cxone-section-header" cvLocalizedText [langSection]="'Quality_Score_Module'" [langKey]="'View'">View</p>
            <label cvLocalizedText [langSection]="'Quality_Score_Module'" [langKey]="'Widget_View'">Widget View</label>
            <cxone-singleselect-dropdown 
                [(ngModel)]="selectedWidgetView"
                [options]="widgetViews"
                [label]="'displayName'"
                [primaryKey]="'viewType'"
                [isRequired]="true"
                [search]="false"
                [showFooter]="false"
                [sortOrder]="'desc'"
                (selectionChanged)="onWidgetViewChanged()">
            </cxone-singleselect-dropdown>
        </div>
        <div *ngIf="selectedWidgetView?.viewType === 'scoreboard'" class="form-group">
            <label cvLocalizedText [langSection]="'Quality_Score_Module'" [langKey]="'View_By'">View By</label>
            <cxone-singleselect-dropdown 
                [(ngModel)]="selectedView"
                [options]="definitions"
                [label]="'displayName'"
                [primaryKey]="'setValue'"
                [isRequired]="true"
                [search]="false"
                [showFooter]="false"
                [sortOrder]="'desc'"
                (selectionChanged)="onViewSelected()">
            </cxone-singleselect-dropdown>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div cvModuleCxoneCustomSettingSection after="emp" [moduleManager]="moduleManager">
        <div class="form-group">
            <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
            <cv-date-paradigm-filter [selectedMetrics]="selectedMetrics" [moduleManager]="moduleManager"></cv-date-paradigm-filter>
            <cv-metric-dynamic-filters [selectedMetrics]="selectedMetrics" [moduleManager]="moduleManager"></cv-metric-dynamic-filters>
        </div>

        <div class="form-group">
            <label cvLocalizedText [langSection]="'Quality_Score_Module'" [langKey]="'Quality_Score_Threshold'">Quality Score Threshold</label>
            <cxone-range-slider [(ngModel)]="settings.rangeValues"
                [min]="0"
                [max]="100"
                [step]="1"
                [startPoints]="points"
                [connect]="connect"
                [colorClasses]="['negativeRange', 'neutralRange', 'positiveRange']"
                [markerValues]="11"
                [enableTooltipOnDrag]="true">
            </cxone-range-slider>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection [moduleManager]="moduleManager">
        <div class="custom-setting-section-body" style="width: 50%; padding: 52px 0px 16px;">
            <cxone-range-slider style="width: 100%; height: 40px;"
                [(ngModel)]="settings.rangeValues"
                [min]="0"
                [max]="100"
                [step]="1"
                [startPoints]="points"
                [connect]="connect"
                [colorClasses]="['negativeRange', 'neutralRange', 'positiveRange']"
                [markerValues]="10">
            </cxone-range-slider>
        </div>
    </div>
</ng-container>

